// src/pages/HomePage.jsx
// @ts-nocheck
import React, { useState, useEffect, useCallback } from 'react';
// La connexion directe à Neon est bien supprimée
import { useLocation } from 'react-router-dom';
import ProspectsList from '../components/ProspectsList';
import SearchBar from '../components/SearchBar';
import Pagination from '../components/Pagination';
import { useLayout } from '../components/Layout';
import { useAuth } from '../context/AuthContext'; // Importez useAuth
import ProspectDetail from '../components/ProspectDetail'; // Importez ProspectDetail

const ETATS_LEAD = [
  'Tous', 'À traiter', 'Nouveau', 'Contacté', 'À rappeler', 'Vente', 
  'Perdu', 'Plus tard', 'Rendez-vous pris', 'Injoignable', 'Ne pas déranger'
];

const HomePage = () => {
  const { refetchCounts, counts } = useLayout();
  const { user, isFournisseur } = useAuth(); // Utilisez useAuth pour obtenir l'utilisateur et son rôle
  const [prospects, setProspects] = useState([]);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterSource, setFilterSource] = useState('');
  const [selectedEtat, setSelectedEtat] = useState('Tous');
  const [dateFilter, setDateFilter] = useState('Tous');
  const [currentPage, setCurrentPage] = useState(1);
  const [prospectsPerPage] = useState(20);
  const [users, setUsers] = useState([]);
  const [etatsLead, setEtatsLead] = useState(['Tous']);
  const [showAddProspectModal, setShowAddProspectModal] = useState(false); // État pour le modal d'ajout

  const location = useLocation();
  
  const getPageContext = () => {
    switch (location.pathname) {
      case '/a-traiter':
        return { title: 'Prospects à traiter', count: counts.aTraiter };
      case '/plus-tard':
        return { title: 'Prospects pour plus tard', count: counts.plusTard };
      case '/rendez-vous':
        return { title: 'Rendez-vous pris', count: counts.rendezVous };
      case '/mes-leads': // Nouvelle route pour les leads du fournisseur
        return { title: 'Mes Prospects', count: counts.myLeads };
      default:
        return { title: 'Liste des Prospects', count: counts.total };
    }
  };

  const { title, count } = getPageContext();

  // CORRECTION: Connexion à l'API pour les utilisateurs
  const fetchUsers = useCallback(async () => {
    try {
      const response = await fetch('https://venteclead.st-info.fr/get_users.php');
      const usersData = await response.json();
      if (usersData && !usersData.error) {
        setUsers(usersData);
      }
    } catch (error) {
      console.error("Erreur lors du chargement des utilisateurs:", error);
    }
  }, []);

  useEffect(() => {
    const fetchEtats = async () => {
      try {
        const response = await fetch('https://venteclead.st-info.fr/get_settings.php');
        const settings = await response.json();
        if (settings && settings.prospect_etat) {
          const finalEtats = ['Tous', ...settings.prospect_etat];
          if (!finalEtats.includes('RAPPEL')) {
            finalEtats.push('RAPPEL');
          }
          setEtatsLead(finalEtats);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des états de lead:", error);
      }
    };
    fetchUsers();
    fetchEtats();
  }, [fetchUsers]);

  // CORRECTION: La fonction de récupération des prospects est la seule partie modifiée
  const fetchProspectsFromDB = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const path = location.pathname;
      let apiUrl = `https://venteclead.st-info.fr/get_prospects.php?path=${encodeURIComponent(path)}`;

      // Ajouter l'ID utilisateur et le rôle si l'utilisateur est connecté
      if (user?.id && user?.role) {
        apiUrl += `&user_id=${user.id}&user_role=${encodeURIComponent(user.role)}`;
      }
      
      const response = await fetch(apiUrl);
      
      if (!response.ok) {
        throw new Error(`Erreur du serveur: ${response.status}`);
      }
      const prospectsData = await response.json();
      
      if (prospectsData.error) {
          throw new Error(prospectsData.error)
      }

      // La logique suivante est conservée à l'identique de votre version originale
      const uniqueSources = [...new Set(prospectsData.map(p => p.source).filter(Boolean))];
      uniqueSources.sort();
      
      setProspects(prospectsData);
      setSources(uniqueSources);

    } catch (err) {
      console.error('Erreur lors de la récupération des prospects:', err);
      // CORRECTION: On utilise EXACTEMENT le même message d'erreur qu'avant
      setError('Impossible de charger les prospects depuis la base de données.');
    } finally {
      setLoading(false);
    }
  }, [location.pathname, user]); // Ajouter user aux dépendances

  useEffect(() => {
    fetchProspectsFromDB();
  }, [fetchProspectsFromDB]);

  // Le reste du fichier est identique à votre version originale...
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterSource, selectedEtat, dateFilter]);

  const handleAddProspect = async (newProspectData) => {
    try {
      const response = await fetch('https://venteclead.st-info.fr/add_prospect.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newProspectData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Réponse invalide du serveur' }));
        throw new Error(errorData.error || `Erreur HTTP ${response.status}`);
      }
      
      const result = await response.json();
      if (result.error) {
        throw new Error(result.error);
      }

      alert("Prospect ajouté avec succès !");
      fetchProspectsFromDB(); // Recharger la liste des prospects
      refetchCounts(); // Mettre à jour les compteurs
    } catch (error) {
      console.error('Erreur lors de l\'ajout du prospect:', error);
      alert(`L\'ajout a échoué: ${error.message}`);
    }
  };

  const handleUpdateProspect = async (prospectToUpdate) => {
    try {
      const response = await fetch('https://venteclead.st-info.fr/update_prospect.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(prospectToUpdate)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Réponse invalide du serveur' }));
        throw new Error(errorData.error || `Erreur HTTP ${response.status}`);
      }
      
      const result = await response.json();
      if (result.error) {
        throw new Error(result.error);
      }

      // Mettre à jour la liste des prospects localement pour un retour immédiat
      setProspects(currentProspects =>
        currentProspects.map(p => (p.id === prospectToUpdate.id ? prospectToUpdate : p))
      );

      // Mettre à jour les compteurs dans la barre latérale
      refetchCounts();

    } catch (error) {
      console.error('Erreur lors de la mise à jour du prospect:', error);
      alert(`La mise à jour a échoué: ${error.message}`);
    }
  };

  const filteredProspects = prospects.filter(p => {
    const matchSearch = (p.nom?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
      (p.prenom?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
      (p.ville?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
      (p.code_postal?.toString() || '').includes(searchTerm) ||
      (p.source?.toLowerCase() || '').includes(searchTerm.toLowerCase()); // NOTE: Utilisation de 'source'
    
    const matchSource = filterSource ? p.source?.trim() === filterSource.trim() : true; // NOTE: Utilisation de 'source'

    const matchEtat = selectedEtat !== 'Tous' ? p.etat_du_lead === selectedEtat : true;

    let matchDate = true;
    if (dateFilter !== 'Tous') {
        const today = new Date();
        const prospectDate = new Date(p.created_at);
        const oneDay = 24 * 60 * 60 * 1000;

        switch (dateFilter) {
            case "Aujourd'hui":
                matchDate = prospectDate.toDateString() === today.toDateString();
                break;
            case '7 derniers jours':
                matchDate = (today - prospectDate) <= 7 * oneDay;
                break;
            case '15 derniers jours':
                matchDate = (today - prospectDate) <= 15 * oneDay;
                break;
            case 'Dernier mois':
                matchDate = (today - prospectDate) <= 30 * oneDay;
                break;
            default:
                break;
        }
    }

    return matchSearch && matchSource && matchEtat && matchDate;
  });

  const indexOfLastProspect = currentPage * prospectsPerPage;
  const indexOfFirstProspect = indexOfLastProspect - prospectsPerPage;
  const currentProspects = filteredProspects.slice(indexOfFirstProspect, indexOfLastProspect);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="bg-white p-6 rounded-lg shadow-md mb-6">
        <div className="flex items-baseline space-x-2 mb-4">
          <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
          <span className="text-2xl font-normal text-gray-500">
            ({count})
          </span>
        </div>
        
        <SearchBar 
          searchTerm={searchTerm} 
          setSearchTerm={setSearchTerm} 
          sources={sources}
          filterSource={filterSource}
          setFilterSource={setFilterSource}
          dateFilter={dateFilter}
          setDateFilter={setDateFilter}
          selectedEtat={selectedEtat}
          setSelectedEtat={setSelectedEtat}
          etatsLead={etatsLead}
        />

        {isFournisseur && (
            <div className="mt-4 flex justify-end">
                <button 
                    onClick={() => setShowAddProspectModal(true)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                    Ajouter un Prospect
                </button>
            </div>
        )}

      </div>

      {loading ? (
        <div className="text-center text-gray-600">Chargement des prospects...</div>
      ) : error ? (
        <div className="text-center text-red-600 bg-red-100 p-4 rounded-md">{error}</div>
      ) : (
        <>
          <ProspectsList prospects={currentProspects} onUpdate={handleUpdateProspect} users={users} />
          <Pagination
            prospectsPerPage={prospectsPerPage}
            totalProspects={filteredProspects.length}
            onPageChange={paginate}
            currentPage={currentPage}
            totalPages={Math.ceil(filteredProspects.length / prospectsPerPage)}
          />
        </>
      )}

    {showAddProspectModal && (
        <ProspectDetail
          prospect={{}} // Passer un objet vide pour un nouvel ajout
          onClose={() => setShowAddProspectModal(false)}
          onAdd={handleAddProspect} // Gérer l'ajout
          users={users}
        />
    )}
    </div>
  );
};

export default HomePage;